import React from "react";

const QuestionRow = ({ label, value, subHeading = false, isLargeScreen = true }) => {
  if (typeof value == 'object' && value.length > 1){

  }
    return (
      <div className="col-12">
        <div className="row my-3 ms-sm-5">
          <div
            className={"col-12 col-md-6 text-primary fw-bold mb-2 mb-md-0"}
            style={{ paddingLeft: subHeading && "25px" }}
          >
            {label}
          </div>
          <div className="col-12 col-md-6 col-sm-8 fw-bold" style={{ paddingLeft: !isLargeScreen && "25px" }}>
            {(typeof value == 'object' && value.length > 1)?
              <>
              <ul>
                {value}
              </ul>
              </>:
            <label>{value}</label>
            }
          </div>
        </div>
      </div>
    );
};

export default QuestionRow;
